export default __webpack_public_path__ + "static/media/GRASZ_JUZ.319b0931.png";